export const taskTemplate = {
    id: 0,
    taskName: '',
    assignedPerson: '',
    startDate: '',
    endDate: '',
    estimatedHours: '',
    status: 'Unresolved',
    description: ''
};